
export const getMonthName = (monthNumber) => {
    let monthNames = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Augosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ];
    let numMonth = monthNumber;
    let month = monthNames[numMonth];
    return month;
};

export const getDateUTMFormat = (date) => {
 return new Intl.DateTimeFormat('es', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(date);
}

export const listUnidad = [
    {  unidad: 'Fardo' , name: 'Fardo' },
    {  unidad: 'Bolsón' , name: 'Bolsón' },
    {  unidad: 'Roll Off', name: 'Roll Off' },
    {  unidad: 'Kilogramos' , name: 'Kilogramos' }
  ]

export const turnos = [
    {  id: 'mañana' , name: 'Mañana' },
    {  id: 'tarde' , name: 'Tarde' },
    {  id: 'noche', name: 'Noche' }
  ]



// WEBPACK FOOTER //
// ./src/utils.js